// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.wrapper[data-v-7f82bd3a] {
  position: relative;
  display: flex;
}
.image[data-v-7f82bd3a] {
  background-color: #fff;
  object-fit: cover;
  border-style: solid;
  border-color: white;
}
.image.medium[data-v-7f82bd3a] {
  border-width: 0.5rem;
  height: 150px;
  width: 150px;
}
.image.small[data-v-7f82bd3a] {
  border-width: 0.25rem;
  height: 85px;
  width: 85px;
}
.buttons[data-v-7f82bd3a] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transform: scale(0.9);
  transition: all var(--transition-duration);
}
*:hover > .buttons[data-v-7f82bd3a] {
  opacity: 1;
  transform: none;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
